import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout/Layout";
import { Header } from "@/components/Header/Header";
import { Loading } from "@/components/Loading/Loading";
import { lessonApi } from "@/services/lessonApi";
import type { Subject } from "@/types/lesson";

export function Dashboard() {
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState<Subject[] | null>(null);

  useEffect(() => {
    lessonApi
      .getSubjects()
      .then(setSubjects)
      .catch(() => setSubjects([]));
  }, []);

  return (
    <Layout>
      <Header title="Choose a Subject" />
      <main className="flex-1 p-4">
        {!subjects ? (
          <div className="flex h-40 items-center justify-center">
            <Loading label="Loading subjects..." />
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
            {subjects.map((s) => (
              <button
                key={s.id}
                onClick={() => {
                  if (s.name.toLowerCase() === "fnat" || s.id === "math") {
                    navigate("/player/fnat");
                  } else {
                    navigate(`/subjects/${s.id}`);
                  }
                }}
                className="flex flex-col items-center gap-2 rounded-3xl bg-white p-6 shadow-md active:scale-95"
                style={{ borderTop: `6px solid ${s.color}` }}
              >
                <span className="text-4xl">{s.icon}</span>
                <span className="text-lg font-extrabold text-slate-700">
                  {s.name}
                </span>
              </button>
            ))}
          </div>
        )}
      </main>
    </Layout>
  );
}
